"use client";

import { type ComponentProps } from "react";
import { Toaster as SonnerToaster } from "sonner";

export function Toaster({
	position = "bottom-right",
}: {
	position?: ComponentProps<typeof SonnerToaster>["position"];
} = {}) {
	return (
		<SonnerToaster
			position={position}
			richColors
			closeButton
			theme="light"
			toastOptions={{
				classNames: {
					toast: "border-border bg-card text-foreground shadow-lift",
				},
			}}
		/>
	);
}
